export default __webpack_public_path__ + "508e712.png";